"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class ExportController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            export: '/v1/export',
        };
    }
    getUrlExport(typeEntity, payload) {
        const urlParams = `query=${encodeURIComponent(JSON.stringify(payload.query))}&options=${encodeURIComponent(JSON.stringify(payload.options))}`;
        return `${this.endpoints.export}?${urlParams}`;
    }
    getExport(typeEntity, payload) {
        return this.manager.get({ url: this.getUrlExport(typeEntity, payload) }, { responseType: 'arraybuffer' });
    }
}
exports.default = ExportController;
